// extracted by mini-css-extract-plugin
module.exports = {"filled":"like-btn_filled__sfKCZ","icon":"like-btn_icon__VzZYC"};